// Selectors


import { RootState } from '../../store';

export const didSelector = (state: RootState) => state.didState
